import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { Icon } from './index';
var SkholeIcon12 = Icon( /*#__PURE__*/_jsx("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 40 40",
  style: {
    enableBackground: 'new 0 0 40 40'
  },
  xmlSpace: "preserve"
}, void 0, /*#__PURE__*/_jsx("path", {
  className: "st1",
  d: "M36.1,16.2c-0.3-0.9-1-1.5-1.9-1.6l-8.4-1.2l-3.7-7.6c0,0,0,0,0,0c-0.4-0.8-1.2-1.3-2.1-1.3s-1.7,0.5-2.1,1.3 l-3.7,7.6l-8.4,1.2c-0.9,0.1-1.6,0.7-1.9,1.6c-0.3,0.9-0.1,1.8,0.6,2.4l6.1,5.9l-1.4,8.3c-0.2,0.9,0.2,1.8,0.9,2.3 c0.4,0.3,0.9,0.5,1.4,0.5c0.4,0,0.8-0.1,1.1-0.3l7.5-3.9l7.5,3.9c0.8,0.4,1.8,0.4,2.5-0.2c0.7-0.5,1.1-1.4,0.9-2.3l-1.4-8.3l6.1-5.9 C36.2,17.9,36.4,17,36.1,16.2z"
})));
export default SkholeIcon12;